import { FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LanguageRadioButtons = (props: { formik: any; showOptional: boolean }): JSX.Element => {
  const { t } = useTranslation('component');
  return (
    <>
      <FormLabel id="LanguageLabel">
        {t('CommunicationPreferences.CommunicationLanguageTitle')} {props.showOptional && t('Form.Optional')}
      </FormLabel>
      <RadioGroup
        aria-labelledby="LanguageLabel"
        onChange={props.formik.handleChange}
        value={props.formik.values.language}>
        <FormControlLabel
          value="fr"
          id="FrenchLanguage"
          control={<Radio name="language" checked={props.formik.values.language == 'fr'} />}
          label={t('Languages.fr')}
        />
        <FormControlLabel
          value="en"
          id="EnglishLanguage"
          control={<Radio name="language" checked={props.formik.values.language === 'en'} />}
          label={t('Languages.en')}
        />
      </RadioGroup>
    </>
  );
};

export default LanguageRadioButtons;
